export default __webpack_public_path__ + "static/media/OnlineCheckout.ee55f8eb.png";